import { Directive, Renderer2, ElementRef } from '@angular/core';

@Directive({
  selector: '[appCustomTooltip]'
})
export class CustomTooltipDirective {
  
  constructor(private elRef: ElementRef, private renderer: Renderer2) {
  }
  ngAfterViewInit () {
    const div = this.renderer.createElement('div')
    div.className = 'tooltip';
    this.renderer.setAttribute(div,'matTooltip','select a value');
    this.renderer.appendChild(this.elRef.nativeElement, div);
  }
  

}
